import Row from '@totallymoney/ui/components/Row'

import { UnscoredLoanProduct } from '@appTypes/LoansApi.interface'

import SameDayDepositInfoBox from '@components/SameDayDepositInfoBox'
import SpecialOfferBadge from '@components/SpecialOfferBadge'

const UnscoredTableItemOffersSection = ({
    hasSameDayDepositBadge,
    item,
}: {
    hasSameDayDepositBadge: boolean
    item: UnscoredLoanProduct
}) => (
    <Row space="space10" flexWrap="wrap">
        {hasSameDayDepositBadge ? <SameDayDepositInfoBox /> : null}

        {item.hasOffer ? (
            <SpecialOfferBadge
                title={item.offerTitle}
                description={item.offerDescription}
            />
        ) : null}
    </Row>
)

export default UnscoredTableItemOffersSection
